import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

export function LocationChoiceDialog({ enteredLocation, options, onSelect, onClose }) {
  return (
    <Dialog open={options.length > 0} onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent className="sm:max-w-lg" showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Choose your base location</DialogTitle>
          <DialogDescription>
            {options.length > 1
              ? `We found more than one ${enteredLocation}. Choose the one you mean.`
              : `Your saved location no longer matches ${enteredLocation}. Confirm the location you mean.`}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-3">
          {options.map((option) => (
            <Button
              key={option.id}
              type="button"
              variant="outline"
              className="h-auto w-full justify-start whitespace-normal p-4 text-left"
              onClick={() => onSelect(option)}
            >
              <span className="grid gap-1">
                <span className="font-semibold text-foreground">{option.label}</span>
                <span className="text-sm text-muted-foreground">
                  {[option.adminDistrict, option.region, option.placeType].filter(Boolean).join(' · ')}
                </span>
              </span>
            </Button>
          ))}
        </div>
        <DialogFooter showCloseButton />
      </DialogContent>
    </Dialog>
  )
}
